import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import "./i18n";
import "./assets/fonts/font.ttf";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
